module.exports = new __parcel__URL__("spotlightImage.33d23bc6.svg").toString();